export const OAUTH_REFRESH_LOCK_KEY = 'sls:oauth-refresh-lock'
export const OAUTH_REFRESH_LOCK_TS_KEY = 'sls:oauth-refresh-lock-ts'
export const OAUTH_ACCESS_UPDATED_KEY = 'sls:oauth-access-updated'
export const OAUTH_TOKEN_UPDATED_EVENT = 'sls:oauth-token-updated'

const LOCK_TTL_MS = 30000
const POLL_MS = 100

export function isRefreshLockHeld() {
  const lockId = window.localStorage.getItem(OAUTH_REFRESH_LOCK_KEY)
  const lockTs = window.localStorage.getItem(OAUTH_REFRESH_LOCK_TS_KEY)
  if (!lockId || !lockTs) {
    return false
  }
  return Date.now() - Number.parseInt(lockTs, 10) < LOCK_TTL_MS
}

export function acquireRefreshLock() {
  const lockId = `${Date.now()}-${Math.random().toString(36).slice(2)}`
  window.localStorage.setItem(OAUTH_REFRESH_LOCK_KEY, lockId)
  window.localStorage.setItem(OAUTH_REFRESH_LOCK_TS_KEY, `${Date.now()}`)
  return lockId
}

export function releaseRefreshLock(lockId) {
  if (window.localStorage.getItem(OAUTH_REFRESH_LOCK_KEY) === lockId) {
    window.localStorage.removeItem(OAUTH_REFRESH_LOCK_KEY)
    window.localStorage.removeItem(OAUTH_REFRESH_LOCK_TS_KEY)
  }
}

export function waitForRefreshLock(maxWaitMs = LOCK_TTL_MS) {
  return new Promise((resolve) => {
    const started = Date.now()
    const tick = () => {
      if (!isRefreshLockHeld() || Date.now() - started >= maxWaitMs) {
        resolve()
        return
      }
      window.setTimeout(tick, POLL_MS)
    }
    tick()
  })
}

export function notifyAccessTokenUpdated(accessToken) {
  window.localStorage.setItem(OAUTH_ACCESS_UPDATED_KEY, `${Date.now()}`)
  window.dispatchEvent(new CustomEvent(OAUTH_TOKEN_UPDATED_EVENT, {
    detail: { accessToken },
  }))
}

export function subscribeAccessTokenUpdated(handler) {
  const onCustomEvent = (event) => {
    handler(event.detail?.accessToken)
  }
  const onStorage = (event) => {
    if (event.key === OAUTH_ACCESS_UPDATED_KEY) {
      handler(null)
    }
  }
  window.addEventListener(OAUTH_TOKEN_UPDATED_EVENT, onCustomEvent)
  window.addEventListener('storage', onStorage)
  return () => {
    window.removeEventListener(OAUTH_TOKEN_UPDATED_EVENT, onCustomEvent)
    window.removeEventListener('storage', onStorage)
  }
}
